export default "__VITE_ASSET__B0ym_9Zo__"